import { useMemo } from 'react';

export function useIsMobile() {
  return useMemo(() => window.matchMedia('(max-width: 640px)').matches, []);
}
